import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { theme } from '../../styles/theme';

interface Props {
  text: string;
}

const Tooltip = styled(motion.div)`
  position: absolute;
  bottom: calc(100% + 12px);
  left: 50%;
  transform: translateX(-50%);
  background: ${theme.colors.text.primary};
  color: white;
  padding: ${theme.spacing.sm} ${theme.spacing.md};
  border-radius: ${theme.radii.md};
  font-size: ${theme.fontSizes.sm};
  white-space: nowrap;
  max-width: 250px;
  box-shadow: ${theme.shadows.lg};
  z-index: 1000;
  pointer-events: none;
  
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: ${theme.colors.text.primary};
  }
`;

export const EducationalTooltip: React.FC<Props> = ({ text }) => {
  return (
    <Tooltip
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 10 }}
      transition={{ duration: 0.2 }}
    >
      {text}
    </Tooltip>
  );
};